module.exports = __webpack_public_path__ + "static/img/jiqi-guang.5cf67a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/jiqi-guang.png
// module id = OK9g
// module chunks = 0